<template>
  <div :class="$options.name">
    <v-row v-show="changeMap || (!hasMap && !buildedMap)">
      <v-col :md="isLoading ? 3 : 12" align-self="center">
        <v-btn
          ref="input"
          :loading="isLoading"
          :disabled="isLoading"
          color="primary"
          width="100%"
        >
          Загрузить снимок
        </v-btn>
      </v-col>

      <v-col md="9" align-self="center">
        <v-progress-linear
          v-if="isLoading"
          height="25"
          :value="progress"
          rounded
        >
          <strong>{{ progress }}%</strong>
        </v-progress-linear>
      </v-col>
    </v-row>
    <v-alert v-if="hasMap && !buildedMap" type="success" border="left" text>
      Снимок успешно загружен и отправлен на обработку,
      производится генерация набора тайлов из представленного снимка.
      Процесс может занять от нескольких секунд до 10 минут.
    </v-alert>
    <template v-else-if="hasMap && buildedMap && !changeMap">
      <v-alert color="primary" border="left" dense text>
        <v-row align="center">
          <v-col class="grow">Снимок успешно обработан и доступен.</v-col>
          <v-col class="shrink">
            <v-btn color="primary" @click="changeMap = true">Сменить снимок</v-btn>
          </v-col>
        </v-row>
      </v-alert>

      <div class="mt-5 preview-container">
        <map-component
          :fit="fit"
          @created="onMapCreated"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Resumable from 'resumablejs';
import { mapActions } from 'vuex';
import MapComponent from '@/components/map';

const CHUNK_SIZE = 1024 * 1024 * 10; // 10mb

export default {
  name: 'orthophotomap-form',
  components: { MapComponent },
  props: {
    objectId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    hasMap: Boolean,
    buildedMap: Boolean,
    fit: Array,
  },
  data: () => ({
    selectedFile: null,
    changeMap: false,
    isLoading: false,
    progress: 0,
  }),
  watch: {
    changeMap(value) {
      if (value) {
        this.init();
        this.resumable.assignBrowse(this.$refs.input.$el);
      } else {
        this.resumable = null;
      }
    },
  },
  created() {
    if (!this.hasMap) {
      this.init();
    }
  },
  mounted() {
    if (!this.hasMap) {
      this.resumable.assignBrowse(this.$refs.input.$el);
    }
  },
  methods: {
    ...mapActions('layer-objects', {
      layerAttachOrthophotomap: 'attachOrthophotomap',
    }),

    ...mapActions('events', {
      eventAttachOrthophotomap: 'attachOrthophotomap',
    }),

    ...mapActions(['showNotify']),

    attachOrthophotomap(params) {
      if (this.objectType === 'events') this.eventAttachOrthophotomap(params);
      else this.layerAttachOrthophotomap({ layerId: this.objectId, params });
    },

    init() {
      this.resumable = new Resumable({
        chunkSize: CHUNK_SIZE,
        simultaneousUploads: 3,
        testChunks: false,
        fileType: ['tar.gz', 'tar', 'zip', 'tif', 'mbtiles'],
        throttleProgressCallbacks: 1,
        // Get the url from data-url tag
        target: `${process.env.VUE_APP_API_V1_URL}/admin/orthophotomaps/upload`,
        headers: {
          Authorization: this.$store.state.auth.access,
        },
      });

      this.resumable.on('fileAdded', this.onFileAdd);
      this.resumable.on('fileProgress', this.onFileProgress);
      this.resumable.on('fileSuccess', this.onFileSuccess);
      this.resumable.on('fileError', this.onFileError);
    },

    onFileError(resumable, json) {
      const { data } = JSON.parse(json);
      if (data.code === 100) {
        this.showNotify({
          type: 'error',
          message: 'Раширение файла может быть tar, tar.gz, zip, tif или mbtiles',
        });
      }
      if (data.code === 400) {
        this.showNotify({
          type: 'error',
          message: `Не удалось загрузить файл. Ошибка: ${data.error}`,
        });
      }
    },

    onFileAdd() {
      this.isLoading = true;
      this.resumable.upload();
    },
    onFileProgress() {
      this.progress = Math.floor(this.resumable.progress() * 100);
    },
    async onFileSuccess(resumable, json) {
      const { fileName } = JSON.parse(json);
      await this.attachOrthophotomap({ fileName });
      this.isLoading = false;
    },

    onMapCreated(instance) {
      const source = {
        id: 'preview-tiles-source',
        type: 'raster',
        tiles: [`${process.env.VUE_APP_API_V1_URL}/layer-objects/${this.objectId}/orthophotomap/{x}/{y}/{z}.png`],
        tileSize: 256,
        scheme: 'tms',
      };

      instance.addSource(source.id, source);

      const layer = {
        id: 'preview-tiles-layer',
        type: 'raster',
        source: source.id,
        paint: {
          'raster-opacity': 0.8,
        },
        minzoom: 0,
        maxzoom: 23,
      };

      instance.addLayer(layer);
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  position: relative;
  width: 100%;
  height: 450px;
}
</style>
